/**
 * «Siamo su uno schermo stretto?», da dentro un componente.
 *
 * Serve dove le classi responsive non arrivano: il testo di un `placeholder`,
 * che non ha una versione per telefono e una per computer. Si aggiorna da
 * solo se la finestra cambia o il telefono ruota.
 */
import { useSyncExternalStore } from "react";

const STRETTO = "(max-width: 639px)";

function iscriviti(callback: () => void): () => void {
  const media = window.matchMedia(STRETTO);
  media.addEventListener("change", callback);
  return () => media.removeEventListener("change", callback);
}

export function useSchermoStretto(): boolean {
  return useSyncExternalStore(
    iscriviti,
    () => window.matchMedia(STRETTO).matches,
    () => false,
  );
}
